
import { mapState } from 'vuex';
import hasStickyData from '..//../mixins/hasStickyData';
import hasNavigation from '..//../mixins/hasNavigation';

export default {
  title: 'NavigationSidebar',
  data() {
    return {
      menuExpanded: false,
      contractedMenu: '',
      expandedMenu: '',
      contracted: {},
    };
  },
  mixins: [hasStickyData, hasNavigation],
  computed: {
    ...mapState('navigation', ['clickInteraction']),
  },

  mounted() {
    this.$nextTick(async () => {
      const menuCollapsed = this.$route?.query?.menuCollapsed;

      if (menuCollapsed !== undefined) {
        // URL param takes precedence — read synchronously before any await
        if (menuCollapsed === 'true') {
          this.closeMenu();
        } else {
          this.openMenu();
        }
      } else {
        // No URL param — fall back to saved preference
        const isOpen = await this.getStickyData('menuOpen');

        if (isOpen === true) {
          this.openMenu();
        } else {
          this.closeMenu();
        }
      }
    });
  },

  methods: {
    widowResize() {
      this.setInitialStates();
    },
    async setInitialStates() {
      // Check if there's a menuCollapsed query parameter
      const menuCollapsed = this.$route?.query?.menuCollapsed;

      if (menuCollapsed === 'true') {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    },

    openMenu() {
      this.menuExpanded = true;
      this.setStickyData('menuOpen', true);
      const element = document.getElementById('__layout');
      if (element) {
        element.classList.add('open');
        element.classList.remove('closed');
      }
    },

    closeMenu() {
      this.menuExpanded = false;
      this.setStickyData('menuOpen', false);
      const element = document.getElementById('__layout');
      if (element) {
        element.classList.add('closed');
        element.classList.remove('open');
      }
    },

    switchMenu() {
      if (this.menuExpanded) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    },
  },
};
